import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxTgModule } from '@worthy-ventures/metaglotta-ngx';

/**
 * Destructive-action confirmation. Replaces window.confirm so the prompt keeps
 * the dashboard's surface and can carry a formatted consequence line.
 *
 * Set the inputs before opening; the modal closes with `true` on confirm and
 * dismisses on cancel, so the caller does the work in the result handler:
 *
 *   const ref = this.modalService.open(ConfirmModalComponent, { centered: true, windowClass: 'auth-modal-window' });
 *   ref.componentInstance.title = 'Delete equipment';
 *   ref.result.then(() => this.doDelete(), () => {});
 */
@Component({
    selector: 'app-confirm-modal',
    imports: [NgxTgModule],
    templateUrl: './confirm-modal.component.html',
    styleUrl: './confirm-modal.component.scss',
})
export class ConfirmModalComponent {
    /** Set by the caller. */
    title = 'Are you sure?';
    /** Main question. The subject is bolded by the template when `subject` is set. */
    message = '';
    /** The thing being acted on, rendered on its own emphasised line. */
    subject = '';
    /** Optional consequence shown in a warning block. */
    consequence = '';
    confirmLabel = 'Delete';
    cancelLabel = 'Cancel';

    constructor(public activeModal: NgbActiveModal) { }
}
